import React from 'react';
import { Redirect, Route, withRouter } from 'react-router';
import { connect } from 'react-redux';
import OverviewShell from '../overview_shell/OverviewShell';

const SupplierAttentionDashboardOverviewPage = ({ childRoutes }): React.ReactElement => {
	return (
		<>
			<Route
				path="/supplier/dashboards/overview"
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: '/supplier/dashboards/overview/all',
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Dashboard"
				tabs={[]}
				onTabChange={() => {}}
				checkTabActive={() => false}
				childRoutes={childRoutes}
			/>
		</>
	);
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = () => ({});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(SupplierAttentionDashboardOverviewPage)
);
